// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card {
  display: flex;
  position: fixed;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 0px gray;
  background-color: white;
  align-items: center;
  justify-content: center;
  padding: 5px;
  z-index: 1;
}
.card > * {
  font-family: "Vodafone Rg", Arial, Helvetica, sans-serif;
}

.height10 {
  height: 10ch;
}

.width35 {
  width: 35ch;
}

.message {
  background-color: white;
  color: black;
}

.fail {
  background-color: red;
  color: white;
  font-weight: bold;
}

.success {
  background-color: green;
  color: white;
  font-weight: bold;
}

.top-right {
  top: 100px;
  right: 25px;
}

.top-left {
  top: 100px;
  left: 25px;
}

.bottom-right {
  bottom: 80px;
  right: 25px;
}

.bottom-left {
  bottom: 80px;
  left: 25px;
}

.center-right {
  top: 50%;
  transform: translateY(-50%);
  right: 25px;
}

.center-left {
  top: 50%;
  transform: translateY(-50%);
  left: 25px;
}

.progress {
  max-width: 25ch;
  width: 25ch;
}

article {
  text-align: center;
}

.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.flex-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  gap: 0.5rem;
}

.height32 {
  height: 32px;
}

.width32 {
  width: 32px;
}

.absolute {
  position: absolute !important;
}

.top {
  top: 0;
}

.right {
  right: 0;
}

.height24 {
  height: 20px;
}

.width24 {
  width: 20px;
}

.close-btn {
  border-radius: 100% !important;
  min-width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  background: rgba(255, 255, 255, 0.7) !important;
  color: black !important;
}`, "",{"version":3,"sources":["webpack://./src/components/notification/notification.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,UAAA;AACJ;AAAI;EACI,wDAAA;AAER;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,uBAAA;EACA,YAAA;AACJ;;AAEA;EACI,qBAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,YAAA;EACA,iBAAA;AACJ;;AAEA;EACI,UAAA;EACA,WAAA;AACJ;;AACA;EACI,UAAA;EACA,UAAA;AAEJ;;AAAA;EACI,YAAA;EACA,WAAA;AAGJ;;AADA;EACI,YAAA;EACA,UAAA;AAIJ;;AAFA;EACI,QAAA;EACA,2BAAA;EACA,WAAA;AAKJ;;AAHA;EACI,QAAA;EACA,2BAAA;EACA,UAAA;AAMJ;;AAHA;EACI,eAAA;EACA,WAAA;AAMJ;;AAHA;EACI,kBAAA;AAMJ;;AAHA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAMJ;;AAHA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AAMJ;;AAHA;EACI,YAAA;AAMJ;;AAHA;EACI,WAAA;AAMJ;;AAHA;EACI,6BAAA;AAMJ;;AAHA;EACI,MAAA;AAMJ;;AAHA;EACI,QAAA;AAMJ;;AAHA;EACI,YAAA;AAMJ;;AAHA;EACI,WAAA;AAMJ;;AAHA;EACI,8BAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,+CAAA;EACA,uBAAA;AAMJ","sourcesContent":[".card{\n    display: flex;\n    position: fixed;\n    border-radius: 5px;\n    box-shadow: 0px 0px 10px 0px gray;\n    background-color: white;\n    align-items: center;\n    justify-content: center;\n    padding: 5px;\n    z-index: 1;\n    &>*{\n        font-family: \"Vodafone Rg\", Arial, Helvetica, sans-serif;\n    }\n}\n\n.height10{\n    height: 10ch;\n}\n\n.width35{\n    width: 35ch;\n}\n\n.message{\n    background-color: white;\n    color: black;\n}\n\n.fail{\n    background-color: red;\n    color: white;\n    font-weight: bold;\n}\n\n.success{\n    background-color: green;\n    color: white;\n    font-weight: bold;\n}\n\n.top-right{\n    top: 100px;\n    right: 25px;\n}\n.top-left{\n    top: 100px;\n    left: 25px;\n}\n.bottom-right{\n    bottom: 80px;\n    right: 25px;\n}\n.bottom-left{\n    bottom: 80px;\n    left: 25px;\n}\n.center-right{\n    top: 50%;\n    transform: translateY(-50%);\n    right: 25px;\n}\n.center-left{\n    top: 50%;\n    transform: translateY(-50%);\n    left: 25px;\n}\n\n.progress{\n    max-width: 25ch;\n    width: 25ch;\n}\n\narticle{\n    text-align: center;\n}\n\n.flex-row{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n}\n\n.flex-column{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-evenly;\n    gap: 0.5rem;\n}\n\n.height32{\n    height: 32px;\n}\n\n.width32{\n    width: 32px;\n}\n\n.absolute{\n    position: absolute !important;\n}\n\n.top{\n    top: 0;\n}\n\n.right{\n    right: 0;\n}\n\n.height24{\n    height: 20px;\n}\n\n.width24{\n    width: 20px;\n}\n\n.close-btn{\n    border-radius: 100% !important;\n    min-width: 0 !important;\n    padding: 0 !important;\n    margin: 0 !important; \n    background: rgba(255, 255, 255, 0.7) !important;\n    color: black  !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
